<script lang="ts" setup>
export interface ButtonProps {
  to: string
  title: string
  target?: string
}

defineProps<ButtonProps>()
</script>

<template>
  <SidebarSection>
    <Button v-animate="{ animation: 'vertical-reveal' }" primary slide :to="to" :target="target">
      {{ title }}
    </Button>
  </SidebarSection>
</template>

<style lang="scss" scoped>
:deep(.button) {
  width: 100%;
}
</style>
